import React from "react";
import { FaStar } from "react-icons/fa";

import ProgressBar from "../common/ProgressBar";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ReviewRatingBreakdown = ({ reviews, ratingDistribution }) => {
  if (!reviews?.length || !ratingDistribution) return null;

  return (
    <div className={styles.ratingDistribution}>
      <h4 className={styles.distributionTitle}>Rating breakdown</h4>
      {[5, 4, 3, 2, 1].map((rating) => {
        const count = ratingDistribution[rating] || 0;
        const percentage =
          reviews.length > 0 ? (count / reviews.length) * 100 : 0;
        return (
          <div key={rating} className={styles.ratingBarRow}>
            <span className={styles.ratingLabel}>
              {rating} <FaStar className={styles.starFilled} size={12} />
            </span>
            <div className={styles.ratingBar}>
              <ProgressBar
                className={styles.ratingBarFill}
                percentage={percentage}
              />
            </div>
            <span className={styles.ratingCount}>{count}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ReviewRatingBreakdown;
